// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/topbar/module';
import './modules/theme/hero-slider/module';
import './modules/theme/category-section/module';
import './modules/theme/info-cards/module';
import './modules/theme/item-merch/module';
import './modules/theme/testimonials/module';
import './modules/theme/brands/module';
import './modules/theme/about-us/module';
import './modules/theme/locations/module';
import './modules/evox/menus/module';

// layouts

// leave me last
import './js/base/base-end';
